import withOverlayControls from '../structure/hoc/withOverlayControls';
import withMainControls from '../structure/hoc/withMainControls';
import withNotification from './internal/withNotification';
import EventCard from './EventCard';
export default withMainControls(withOverlayControls(withNotification(EventCard)));